import * as React from 'react'
import { navigateTo } from 'gatsby-link'
import cc from 'classcat'
import Expandable from '../Expandable'

import s from './styles.module.css'

// const locales = [{ label: 'eng', path: 'en' }, { label: 'hrv', path: 'hr' }]
const locales = [{ label: 'eng', path: 'en' }]

const defaultLocale = 'en'

export default class LanguageDropdown extends React.Component {
  onLocaleChange = (newLocale, collapseDropdown) => () => {
    const { locale, onLocaleChange } = this.props

    if (typeof location === 'undefined') {
      return
    }

    const isHomePage = location.pathname.indexOf(`${locale}/`) === -1

    const isDefault = newLocale === defaultLocale

    const newPath = isHomePage
      ? `/${isDefault ? '' : newLocale}`
      : location.pathname.replace(locale, newLocale)

    collapseDropdown()
    onLocaleChange(newLocale)
    navigateTo(newPath)
  }

  render() {
    const {
      locale,
      className,
      dropdownClassName,
      caretClassName,
      triggerClassName
    } = this.props

    const localeObject = locales.find(({ path }) => path === locale)
    const localeLabel = localeObject ? localeObject.label : ''

    return (
      <Expandable
        className={cc([s.languageDropdownWrapper, className])}
        labelClassName={cc([s.languageDropdownTrigger, triggerClassName])}
        caretClassName={cc([s.languageDropdownIcon, caretClassName])}
        label={localeLabel}
        render={({ expanded, collapse }) => (
          <div className={cc([s.languageDropdown, dropdownClassName])}>
            {locales.map(({ label, path }, idx) => (
              <button
                key={idx}
                className={s.localeOption}
                onClick={this.onLocaleChange(path, collapse)}
              >
                {label}
              </button>
            ))}
          </div>
        )}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LanguageDropdown/index.js